import { createSlice } from "@reduxjs/toolkit";
import { FetchOrderStatus } from "./orderStatusAction";

interface OrderState {
  order: any | null;
  loading: boolean;
  error: string | null;
  totalRecord: number;
}

const initialState: OrderState = {
  order: [],
  loading: false,
  error: null,
  totalRecord:0
};

const orderStatusSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(FetchOrderStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FetchOrderStatus.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.order = payload.data; // Store full order details
        state.totalRecord = payload?.totalRecord || 0;
      })
      .addCase(FetchOrderStatus.rejected, (state, { payload }) => {
        state.loading = false;
        state.error =
          (payload as { responseMessage?: string })?.responseMessage || "Failed to fetch order status";
      });
  },
});

export const orderStatusReducer = orderStatusSlice.reducer;
